import { DatosRefirmaPorId, ActualizarEstadoRefirma } from "../../../application/interactors/ReFirma";

export const DatosRefirmaPorIdLogic = (selListaPersona: any, IdCambioPersona: number) => {
    return DatosRefirmaPorId(selListaPersona, IdCambioPersona);
}

export const ActualizarEstadoRefirmaLogic = (selListaEstado: any, idSolicitud: number, estadoSolicitud: number, usuario: string) => {
    return ActualizarEstadoRefirma(selListaEstado, idSolicitud, estadoSolicitud, usuario);
}
